document.addEventListener('DOMContentLoaded', function () {
  var modal = document.getElementById('quick-view-modal');
  console.log('[quick-view] script loaded. modal found:', !!modal);
  if (!modal) {
    console.warn('[quick-view] #quick-view-modal not found in DOM — check that snippet "quick-view-modal" is rendered in theme.liquid');
    return;
  }

  var modalBody = modal.querySelector('.quick-view-modal__body');

  function openModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('quick-view-lock-scroll');
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('quick-view-lock-scroll');
    modalBody.innerHTML = '';
  }

  modal.querySelectorAll('[data-quick-view-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  // Delegate clicks so this works for cards rendered/re-rendered dynamically (filters, infinite scroll, etc.)
  // Attached with `capture: true` so this runs BEFORE any theme/app script that makes
  // the whole product card clickable (those typically listen on the bubble phase
  // and would otherwise redirect to the PDP before our handler gets a chance to run).
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-view-handle]');
    if (!trigger) return;
    console.log('[quick-view] trigger clicked:', trigger.getAttribute('data-quick-view-handle'));
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var handle = trigger.getAttribute('data-quick-view-handle');
    modalBody.innerHTML = '<div class="quick-view-loading">Loading...</div>';
    openModal();

    fetch('/products/' + handle + '?section_id=quick-view-product')
      .then(function (res) {
        if (!res.ok) throw new Error('Request failed');
        return res.text();
      })
      .then(function (html) {
        modalBody.innerHTML = html;
        initVariantSwitching(modalBody);
        initAddToCart(modalBody);
      })
      .catch(function () {
        modalBody.innerHTML = '<p class="quick-view-error">Sorry, this product could not be loaded.</p>';
      });
  }, true);

  function initVariantSwitching(container) {
    var selectors = container.querySelectorAll('.quick-view-option-selector');
    var variantDataEl = container.querySelector('.quick-view-variant-data');
    if (!selectors.length || !variantDataEl) return;

    var variants = JSON.parse(variantDataEl.textContent);

    function getSelectedOptions() {
      return Array.prototype.map.call(selectors, function (sel) {
        return sel.value;
      });
    }

    function findMatch() {
      var selected = getSelectedOptions();
      return variants.filter(function (v) {
        return selected.every(function (val, i) {
          return v['option' + (i + 1)] === val;
        });
      })[0];
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateVariant() {
      var match = findMatch();
      var idInput = container.querySelector('.quick-view-variant-id');
      var priceEl = container.querySelector('.quick-view-content__price');
      var addBtn = container.querySelector('.quick-view-add-to-cart');
      if (!match) return;

      idInput.value = match.id;

      if (priceEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          priceEl.innerHTML =
            '<span class="quick-view-content__price--sale">' + formatMoney(match.price) + '</span> ' +
            '<span class="quick-view-content__price--compare">' + formatMoney(match.compare_at_price) + '</span>';
        } else {
          priceEl.innerHTML = '<span>' + formatMoney(match.price) + '</span>';
        }
      }

      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
      }
    }

    selectors.forEach(function (sel) {
      sel.addEventListener('change', updateVariant);
    });
  }

  function initAddToCart(container) {
    var form = container.querySelector('.quick-view-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var submitBtn = form.querySelector('.quick-view-add-to-cart');
      var originalText = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (data.status) {
            submitBtn.textContent = 'Error';
          } else {
            submitBtn.textContent = 'Added!';
            // Let the theme's cart drawer/notification know the cart changed.
            // Most Dawn-based themes listen for one of these — adjust to match your theme.
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          }
        })
        .catch(function () {
          submitBtn.textContent = 'Error';
        })
        .finally(function () {
          setTimeout(function () {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }, 1500);
        });
    });
  }
});
